import { NavigationItem } from "../../../types/interfaces/navigation";
import { UserRole, isAdminRole } from "../../../types/common/permissions";
import { ModeratorResponse } from "../../../types/api/moderators";
import { ModeratorPermissionsResponse } from "../../../types/api/moderators";
import {
  PeopleIcon,
  KeyAsteriskIcon,
  ListUnorderedIcon,
  GraphIcon,
  PersonIcon,
  CommentIcon,
  BellIcon,
  QuestionIcon,
  LogIcon,
} from "@primer/octicons-react";

export const navigationItems = (profile: ModeratorResponse | null) => {
  const { role, permissions = {} as Partial<ModeratorPermissionsResponse> } =
    profile || {};
  const isAdmin = isAdminRole(role);
  const usersPerm: (keyof ModeratorPermissionsResponse)[] = ["canViewUsers"];
  const adminPerm: (keyof ModeratorPermissionsResponse)[] = ["canViewAds"];
  const metricsPerm: (keyof ModeratorPermissionsResponse)[] = [
    "canViewDashboardMetrics",
  ];

  const items: NavigationItem[] = [
    ...(isAdmin || usersPerm.every((perm) => permissions[perm])
      ? [
          {
            text: "Пользователи",
            href: "/users",
            icon: PeopleIcon,
            isActive: true,
          },
        ]
      : []),
    ...(isAdmin || adminPerm.every((perm) => permissions[perm])
      ? [
          {
            text: "Объявления",
            href: "/ads",
            icon: KeyAsteriskIcon,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            text: "Разделы и подразделы",
            href: "/sections",
            icon: ListUnorderedIcon,
          },
        ]
      : []),
    ...(isAdmin || metricsPerm.every((perm) => permissions[perm])
      ? [
          {
            text: "Метрики",
            href: "/metrics",
            icon: GraphIcon,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            text: "Aloix lead scoring",
            href: "/scoring",
            icon: LogIcon,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            text: "Модераторы",
            href: "/moderators",
            icon: PersonIcon,
          },
        ]
      : []),
    // ...(isAdmin
    //   ? [
    //       {
    //         text: "Форумы",
    //         href: "/forums",
    //         icon: CommentIcon,
    //       },
    //     ]
    //   : []),
    {
      text: "Форумы",
      href: "/forums",
      icon: CommentIcon,
    },
    ...(isAdmin
      ? [
          {
            text: "Уведомления",
            href: "/notifications",
            icon: BellIcon,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            text: "Помощь",
            href: "/help",
            icon: QuestionIcon,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            text: "Логирование действий",
            href: "/logs",
            icon: LogIcon,
          },
        ]
      : []),
  ];

  return items;
};
